export default {
  submitButton: {
    id: 'checkout_step_addresses_submit',
    defaultMessage: 'Next',
  },
}
